const PaymentStatusChip = ({ status, label }) => {
	const className = status === 'paid'
		? 'scout-settings-status-chip scout-settings-status-chip--paid'
		: status === 'late'
			? 'scout-settings-status-chip scout-settings-status-chip--late'
			: 'scout-settings-status-chip scout-settings-status-chip--open'

	return <span className={className}>{label}</span>
}

export default PaymentStatusChip